/**
 * @param {Function} callback
 * @param {number?} timeout
 * @return {Promise<*>}
 */
export async function asyncSetTimeout(callback, timeout){
    return new Promise((resolve, reject) => {
        setTimeout(() =>{
            try{
                let res = callback?.();
                resolve(res);
            } catch (e){
                reject(e);
            }
        }, timeout);
    });
}

/**
 * @param {Function?} callback
 * @return {Promise<*>}
 */
export async function nextAnimationFrame(callback){
    return new Promise((resolve, reject) => {
        window.requestAnimationFrame(() =>{
            try{
                let res = callback?.();
                resolve(res);
            } catch (e){
                reject(e);
            }
        });
    });
}

/**
 * @param {Function?} callback
 * @return {Promise<*>}
 */
export async function nextTick(callback){
    return asyncSetTimeout(callback ?? (() => {}));
}

export async function executeUntil(callback, retry){
    for(let i=0; i< retry; i++){
        await nextTick();
        try {
            let res = callback();
            if(res){
                return res;
            }
        } catch (e){
            Log.fatal(e);
        }
        await nextAnimationFrame();
    }
    return undefined;
}
